import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from './Tooltip';
import { Help } from '../icons';

import './HelpTooltip.scss';

const TooltipTrigger = forwardRef((props, ref) => (
  <span 
    ref={ref} 
    className="tooltip-container" 
    tabIndex="0" 
    {...props}
  >
    {/* Removed altText to kill the native gray browser tooltip */}
    <Help className="tooltip-icon" />
  </span>
));

TooltipTrigger.displayName = 'TooltipTrigger';

const HelpTooltip = ({ html }) => {
  const { t } = useTranslation();

  return (
    <Tooltip interactive content={<span>{html}</span>} arrow>
      <TooltipTrigger />
    </Tooltip>
  );
};

HelpTooltip.propTypes = {
  html: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export default HelpTooltip;
